import React from 'react';
import '../../styles/section.css';
import Header from '../../components/Header';
import Footer from '../../components/Footer';

function Foundations() {
    return (
        <div className="section-container">
            <Header />
            <main className="section-content">
                <p className="section-intro-paragraph">Probably some stuff you should know beforehand</p>
                <div className="subsection-links">
                    <a href="/foundations/python">Python & Libraries</a>
                    <a href="/foundations/linalg">Linear Algebra</a>
                    <a href="/foundations/calc">Calculus</a>
                    <a href="/foundations/probstat">Probability & Statistics</a>
                    <a href="/foundations/nn">Neural Networks & Regularization</a>
                </div>
            </main>
            <Footer />
        </div>
    );
}

export default Foundations;